var render, staticRenderFns
import script from "./ProductsVisitedLazy.vue?vue&type=script&lang=js&"
export * from "./ProductsVisitedLazy.vue?vue&type=script&lang=js&"
import style0 from "./ProductsVisitedLazy.vue?vue&type=style&index=0&id=72fe5c2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports